import * as go from 'gojs';
import { getImageGrizzlyFeeder } from 'unitData/Feeders/Grizzly/getImageGrizzlyFeeder';
import {
  getImageBinding,
  getIOPort,
  getOutputPortPanel,
  makeNode,
} from '../../utils';

const alignGrizzlyPorts = (
  mirrored: boolean,
  portIndex: number,
  nbrOfOutputs?: number,
) => {
  const x = mirrored ? 0 : 1;
  if (nbrOfOutputs === 2) {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 5 / 6);
      case 1:
        return new go.Spot(0.5, 1);
    }
  } else if (nbrOfOutputs === 3) {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 4 / 6);
      case 1:
        return new go.Spot(x, 5 / 6);
      case 2:
        return new go.Spot(0.5, 1);
    }
  } else {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 5 / 6);
    }
  }
};

const GrizzlyFeederTemplate = makeNode(
  getImageBinding('', getImageGrizzlyFeeder),
  [
    getIOPort(go.Spot.Top, 'input'),
    getOutputPortPanel(0, alignGrizzlyPorts),
    getOutputPortPanel(1, alignGrizzlyPorts, (node) => node.nbrOfOutputs > 1),
    getOutputPortPanel(2, alignGrizzlyPorts, (node) => node.nbrOfOutputs > 2),
  ],
);

export default GrizzlyFeederTemplate;
